import { FC, useState } from 'react';
import styled from 'styled-components';
import DatePicker from 'react-datepicker';
import Button from '../Button';

const inputStyles = `
  position: relative;
  width: 100%;
  border-radius: 0.25rem;
  border-width: 1px;
  border-color: rgba(209, 213, 219, var(--tw-border-opacity));
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  padding: 0.5rem 1rem;
  color: rgba(75, 85, 99, var(--tw-text-opacity));
`;

const FilterContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr) min-content;
  grid-gap: 1rem;
  width: 100%;
`;

const InputGroup = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  whitespace: nowrap;
  align-items: center;
`;

const Select = styled.select(() => {
  return `
    ${inputStyles};
  `;
});

const Label = styled.label(({ theme }) => {
  const { type } = theme;

  return `
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
    font-size: ${type.size.regular};
    line-height: 1;
    margin-bottom: 0;
    white-space: nowrap;
    padding-right: 0.5rem;
  `;
});

const StyledDatePicker = styled(DatePicker)`
  ${inputStyles}
`;

export type Filter = {
  createdBy?: string;
  fromDate?: Date;
  toDate?: Date;
};

export type Creator = {
  id: number;
  firstName: string;
  lastName: string;
};

export interface ITournamentFilter {
  filterCallback: (args: Filter) => void;
  creators: Creator[];
}

const TournamentFilters: FC<ITournamentFilter> = ({ creators, filterCallback }) => {
  const [createdBy, setCreatedBy] = useState<string>('-1');
  const [fromDate, setFromDate] = useState<Date>();
  const [toDate, setToDate] = useState<Date>();

  const handleFilter = (): void => {
    filterCallback({
      createdBy,
      fromDate,
      toDate,
    });
  };

  let creatorLoop: JSX.Element[] = [];

  if (creators) {
    creatorLoop = creators.map((creator, index) => {
      const { id, firstName, lastName } = creator;
      return (
        <option key={`creatorOption-${firstName}${lastName}-${index}`} value={id}>
          {firstName} {lastName}
        </option>
      );
    });
  }

  return (
    <FilterContainer>
      <InputGroup>
        <Label htmlFor="createdBy">Created by</Label>
        <Select id="createdBy" name="createdBy" onChange={(e) => setCreatedBy(e.target.value)} value={createdBy}>
          <option value="-1">Everyone</option>
          {creatorLoop}
        </Select>
      </InputGroup>

      <InputGroup>
        <Label htmlFor="fromDate">From</Label>

        <StyledDatePicker
          id="fromDate"
          selected={fromDate}
          startDate={fromDate}
          endDate={toDate}
          selectsStart
          dateFormat="Pp"
          onChange={(date: Date) => setFromDate(date)}
        />
      </InputGroup>

      <InputGroup>
        <Label htmlFor="toDate">To</Label>
        <StyledDatePicker
          id="toDate"
          selected={toDate}
          startDate={fromDate}
          endDate={toDate}
          minDate={fromDate}
          selectsEnd
          dateFormat="Pp"
          onChange={(date: Date) => setToDate(date)}
        />
      </InputGroup>

      <Button type="button" onClick={handleFilter}>
        Filter
      </Button>
    </FilterContainer>
  );
};

export default TournamentFilters;
